<template>
  <IziGrid>
    <IziCol xl="2">{{ room.roomId }}</IziCol>
    <IziCol xl="3">{{ room.host }}</IziCol>
    <IziCol xl="3">{{ room.hostLevel }}</IziCol>
    <IziCol xl="2">{{ room.members }}</IziCol>
    <IziCol xl="2">{{ room.status }}</IziCol>
  </IziGrid>
</template>

<script lang="ts">
import { Options } from "vue-class-component";
import Base from "../base/Base.vue";
@Options({
  props: ["room"]
})
export default class RoomCard extends Base {
  room!: any;
}
</script>
